import { Users, BookOpen, CalendarCheck, Award } from 'lucide-react';

export type DashboardStat = {
    label: string;
    value: string | number;
    description: string;
    icon: React.ElementType;
    accent: string;
};

interface Props {
    learners: number;
    activePrograms: number;
    classesAttended: number;
    programsCompleted: number;
}

export default function StatsCards({
    learners,
    activePrograms,
    classesAttended,
    programsCompleted,
}: Props) {
    const stats: DashboardStat[] = [
        {
            label: 'Learners',
            value: learners,
            description: 'Children on your account',
            icon: Users,
            accent: 'from-[#AA468F]/15 to-[#F3ECFF]',
        },
        {
            label: 'Active Programs',
            value: activePrograms,
            description: 'Currently enrolled',
            icon: BookOpen,
            accent: 'from-sky-500/15 to-sky-50',
        },
        {
            label: 'Classes Attended',
            value: classesAttended,
            description: 'Sessions logged',
            icon: CalendarCheck,
            accent: 'from-emerald-500/15 to-emerald-50',
        },
        {
            label: 'Programs Completed',
            value: programsCompleted,
            description: 'Ready for certificates',
            icon: Award,
            accent: 'from-amber-500/15 to-amber-50',
        },
    ];

    return (
        <div className="grid grid-cols-2 gap-2.5 sm:gap-3 lg:grid-cols-4 lg:gap-4">
            {stats.map((stat) => {
                const Icon = stat.icon;
                return (
                    <div
                        key={stat.label}
                        className="group min-w-0 rounded-[16px] border border-[#efe6f1] bg-white p-3 shadow-[0_8px_30px_rgba(136,22,122,0.05)] transition hover:-translate-y-0.5 hover:shadow-[0_14px_40px_rgba(136,22,122,0.1)] sm:rounded-[20px] sm:p-5"
                    >
                        <div
                            className={`mb-2.5 flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br sm:mb-3 sm:h-11 sm:w-11 sm:rounded-2xl ${stat.accent} text-ryd-primary`}
                        >
                            <Icon size={18} />
                        </div>
                        <p className="truncate text-[10px] font-medium uppercase tracking-wide text-[#94a3b8] sm:text-[12px]">
                            {stat.label}
                        </p>
                        <p className="mt-1 font-[AvertaStd-Semibold] text-[22px] leading-none text-ryd-headerTextPrimary sm:text-[28px]">
                            {stat.value}
                        </p>
                        <p className="mt-1.5 line-clamp-2 text-[11px] text-[#8b9aab] sm:text-[13px]">
                            {stat.description}
                        </p>
                    </div>
                );
            })}
        </div>
    );
}
